var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.17579607572421196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 300 0 L 300 300 L 0 300 Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 300 0 L 300 300 L 0 300 Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1, 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 300 0 L 300 300 L 0 300 Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.17579607572421196)",
    transform: "scale(1, 1)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.de87c5fc0b93909bf1539f1763f3e527.svg";
export { ForwardRef as ReactComponent };